import Whitespace from 'pricing-pages-ui/components/common/Whitespace';
import { commonAvailableTermsSelector } from 'pricing-pages-ui/selectors/OfferSelectors';
import { useSelector } from 'react-redux';
import { currentSuiteSkuIdsForProductLevelSelector } from '../../selectors/ProductsSelectors';
import DetailedTermSelector from '../common/TermSelectors/DetailedTermSelector';
import { jsx as _jsx } from "react/jsx-runtime";
const SuiteTermSelectorContainer = ({
  queryParamTerm,
  productLevel,
  onChange,
  trackingSource
}) => {
  const skuIds = useSelector(reduxState => {
    return currentSuiteSkuIdsForProductLevelSelector(reduxState, {
      productLevel
    });
  });
  const productConfigurations = skuIds.map(skuId => {
    return {
      skuId,
      quantity: 1
    };
  });
  const hasMultipleTerms = useSelector(reduxState => commonAvailableTermsSelector(reduxState, {
    skuIds
  })).length > 1;
  if (!hasMultipleTerms) {
    return /*#__PURE__*/_jsx(Whitespace, {
      height: 41
    });
  }
  const trackingSourceString = `${trackingSource}-${productLevel.toLowerCase()}`;
  const termSelectorToShow = /*#__PURE__*/_jsx(DetailedTermSelector, {
    productConfigurations: productConfigurations,
    onChange: onChange,
    trackingSource: trackingSourceString,
    activeTerm: queryParamTerm
  });
  return termSelectorToShow;
};
export default SuiteTermSelectorContainer;